import { render, staticRenderFns } from "./PhieuCocLienTuc.vue?vue&type=template&id=36b988c8"
import script from "./PhieuCocLienTuc.vue?vue&type=script&lang=js"
export * from "./PhieuCocLienTuc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports